import { VALID_WALLET_LINK_STATUSES, WalletApiFetchState } from "@swiggy-private/payment-core";

export type WalletBalanceState = {
    [key: string]: WalletBalanceStateValue;
};

export type WalletBalanceStateValue = {
    fetchState: WalletApiFetchState;
    linkStatus: VALID_WALLET_LINK_STATUSES;
    balance: number;
    mobileNumber: string;
    isOldWalletLinkFlow: boolean;
    payableAmount?: string;
    paymentMethodDisabled?: boolean;
};

export const defaultWalletBalanceStateValue: WalletBalanceStateValue = {
    fetchState: WalletApiFetchState.DEFAULT,
    linkStatus: VALID_WALLET_LINK_STATUSES.NEVER_LINKED,
    balance: 0,
    isOldWalletLinkFlow: false,
    mobileNumber: "",
};

export enum GetWalletBalanceActionTypes {
    REQUEST,
    SUCCESS,
    ERROR,
}

export type GetWalletBalanceAction =
    | { type: GetWalletBalanceActionTypes.REQUEST; name: string }
    | { type: GetWalletBalanceActionTypes.SUCCESS; name: string; payload: Omit<WalletBalanceStateValue, "fetchState"> }
    | { type: GetWalletBalanceActionTypes.ERROR; name: string };

export function getWalletBalanceReducer(state: WalletBalanceState, action: GetWalletBalanceAction): WalletBalanceState {
    switch (action.type) {
        case GetWalletBalanceActionTypes.REQUEST:
            return {
                ...state,
                [action.name]: {
                    ...(state[action.name] ?? {}),
                    fetchState: WalletApiFetchState.LOADING,
                },
            };
        case GetWalletBalanceActionTypes.SUCCESS:
            return {
                ...state,
                [action.name]: {
                    ...(state[action.name] ?? {}),
                    ...action.payload,
                    fetchState: WalletApiFetchState.SUCCESS,
                },
            };
        case GetWalletBalanceActionTypes.ERROR:
            return {
                ...state,
                [action.name]: {
                    ...(state[action.name] ?? {}),
                    fetchState: WalletApiFetchState.ERROR,
                },
            };
    }
}
